import { jsx as _jsx } from "react/jsx-runtime";
import { PageWrapper } from 'libs.react';
import { DataViewsDashboard } from '../../components/data_views_dashboard/data_views_dashboard.component';
const DataViewsDashboardPage = () => {
    return (_jsx(PageWrapper, { children: _jsx(DataViewsDashboard, {}) }));
};
export default DataViewsDashboardPage;
